import React from 'react'
import { TenantInformation } from './components/TenantInformation'
import { ManageAdmins } from './components/ManageAdmins'

function Profile() {
  return (
    <div className=' flex gap-4'>
      <div className='w-1/2 pr-8'>
        <TenantInformation />
      </div>
      <div className='w-1/2'>
        {/* <ManageAdmins /> */}
      </div>
    </div>
  )
}

export { Profile }
